import React from "react";
import { Helmet } from "react-helmet";
import Page from "src/components/Page";
import View from "./view";

function index(props) {
  localStorage.removeItem("@storeAuctionLot");
  const search = window.location.search;
  const params = new URLSearchParams(search); 
  const data = params.get('data');
  return (
    <>
    <Helmet>

        <meta itemprop="name" content="Leon Gallery International Location | Explore Global Art Collections" />
    <meta property="og:title" content="Leon Gallery International Location | Explore Global Art Collections" />
    <meta name="twitter:title" content="Leon Gallery International Location | Explore Global Art Collections" />
    <meta itemprop="description" content="Discover the international location of Leon Gallery, where you can explore exclusive collections of Philippine and global art. Explore masterpieces from renowned artists available for acquisition worldwide." /> 
    <meta property="og:description" content="Discover the international location of Leon Gallery, where you can explore exclusive collections of Philippine and global art. Explore masterpieces from renowned artists available for acquisition worldwide." />  
    <meta name="twitter:description" content="Discover the international location of Leon Gallery, where you can explore exclusive collections of Philippine and global art. Explore masterpieces from renowned artists available for acquisition worldwide." />
    <meta itemprop="image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
    <meta property="og:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" />
    <meta name="twitter:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 

    </Helmet>

    <Page title="Galleries | Leon Gallery Premier Art Auction House in the Philippines">
     <View param={data}/>
    </Page>
    </>
  );
}

export default index;
